import { useState } from 'react';
import { toast } from 'react-toastify';
import { useChangePasswordMutation } from '@/store/api/authApi';
import { changePasswordSchema } from '@/utils/validation';
import PasswordInput from '@/components/common/PasswordInput';
import { PrimaryButton } from '@/components/common/PrimaryButton';

export default function ChangePassword() {
  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
  });

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const handleChange = (key: string, value: string) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: '' }));
  };

  const handleSubmit = async () => {
    if (isLoading) return;
    try {
      const result = changePasswordSchema.safeParse(form);

      if (!result.success) {
        const fieldErrors: Record<string, string> = {};

        result.error.errors.forEach((err) => {
          const key = err.path.join('.');
          fieldErrors[key] = err.message;
        });

        setErrors(fieldErrors);
        return;
      }

      setErrors({});

      await changePassword({
        oldPassword: form.oldPassword,
        newPassword: form.newPassword,
      }).unwrap();

      toast.success('Password changed successfully ');

      setForm({
        oldPassword: '',
        newPassword: '',
      });
    } catch (err: any) {
      toast.error(err?.data?.message || 'Something went wrong');
    }
  };

  return (
    <div className="max-w-3xl mx-auto bg-black p-6 rounded-xl border border-white/10">
      <h2 className="text-xl font-bold mb-4 text-white">Change Password</h2>

      <div className="mb-4">
        <PasswordInput
          label="Old Password"
          required
          value={form.oldPassword}
          onChange={(e) => handleChange('oldPassword', e.target.value)}
          error={errors.oldPassword}
        />
      </div>

      <div className="mb-8">
        <PasswordInput
          label="New Password"
          required
          value={form.newPassword}
          onChange={(e) => handleChange('newPassword', e.target.value)}
          error={errors.newPassword}
        />
      </div>

      <div className="justify-self-end mt-4">
        <PrimaryButton onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Updating...' : 'Change Password'}
        </PrimaryButton>
      </div>
    </div>
  );
}
